import React from "react";

interface SidebarButtonProps {
  icon: string;
  label: string;
  active: boolean;
  onClick: () => void;
}

export const SidebarButton: React.FC<SidebarButtonProps> = ({
  icon,
  label,
  active,
  onClick,
}) => {
  return (
    <div
      className={`profile-button ${active ? "active" : ""}`}
      onClick={onClick}
    >
      <img src={icon} alt={label} />
      <div>{label}</div>
    </div>
  );
};
